import { render, staticRenderFns } from "./DialogAlert.vue?vue&type=template&id=a6693348&"
import script from "./DialogAlert.vue?vue&type=script&lang=js&"
export * from "./DialogAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VAlert,VDialog})
